<template>
  <select
    ref="tipoJuego"
    v-model="valor"
    @input="updateModel()"
    @change="emitChange()"
  >
    <template v-for="(tipo, index) in tiposJuego">
      <option :value="tipo.id" :key="index">{{ tipo.nombre }}</option>
    </template>
  </select>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<script>
export default {
  name: "selectTipoJuego",
  components: {},
  props: ["GOLF", "TOPTRACER", "editing"],
  data() {
    return {
      tiposJuego: [],
      valor: "",
      MainDepartamento: "",
    };
  },
  methods: {
    async getTiposJuego() {
      let url = "RVA/Tarifas/" + this.MainDepartamento + "/Modalidades";

      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        url
      );

      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
        if (!this.editing) {
          if (element[1]["Codigo"] == "18HOLES") {
            this.valor = element[0];
            this.$emit("input", element[0]);
          }
        }
      });
    },
    updateModel() {
      this.$emit("input", this.$refs.tipoJuego.value);
      this.$emit("onChange");
    },
    emitChange() {
      this.$emit("onChange");
    },
  },
  computed: {},
  watch: {},
  beforeMount: function() {},
  async mounted() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");

    if (this.GOLF) {
      this.MainDepartamento = "Golf";
    }
    if (this.TOPTRACER) {
      this.MainDepartamento = "TopTracer";
    }

    await this.getTiposJuego();
  },
  created() {},
};
</script>
